import { graphql } from "@cappelendamm/crystallize-types/orders/gql";
import Logger from "@cappelendamm/logger";
import { z } from "zod/v4";
import { OrderType } from "../constants.js";
import { cartCustomerSchema } from "../../cart/schemas.js";
const customPayment = z.object({
    provider: z.enum(["custom"]),
    custom: z.object({
        properties: z
            .tuple([
            z.object({
                property: z.literal("identifier"),
                value: z.literal("invoice"),
            }),
        ])
            .or(z.tuple([
            z.object({
                property: z.literal("identifier"),
                value: z.literal("nets"),
            }),
            z.object({
                property: z.literal("netsPaymentId"),
                value: z.string(),
            }),
        ])),
    }),
});
const paymentSchema = z.tuple([customPayment]);
export const orderCustomerInputSchemas = cartCustomerSchema.omit({
    isGuest: true,
});
const orderTypeSchema = z.enum(OrderType);
const orderTypeKeySchema = z.literal("orderType");
const metaKeysSchema = z.enum(["originalOrderId"]);
const metaSchema = z
    .tuple([
    z.object({
        key: orderTypeKeySchema,
        value: orderTypeSchema,
    }),
])
    .rest(z.object({ key: z.string(), value: z.string() }));
export const createOrder = async (input, { client }) => {
    paymentSchema.parse(input.payment);
    metaSchema.parse(input.meta);
    orderCustomerInputSchemas.parse(input.customer);
    Logger.log("Creating order in Crystallize: ", JSON.stringify(input));
    const data = await client.orders.request(graphql(`
      mutation CreateOrder($input: CreateOrderInput!) {
        orders {
          create(input: $input) {
            id
          }
        }
      }
    `), { input });
    return data.orders.create.id;
};
